<form *ngIf="this.identityTypeResponse">
  <div class="card card-login">
    <div class="card-content">

      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img src="assets/img/able/NewEra_ABLE_Master_Logo_CMYK.png" class="logo" alt="able+" title="able+" />
            <h4>Set security questions</h4>
            <span>
              Select <span
                *ngIf="this.identityTypeResponse != undefined">{{this.identityTypeResponse.minSecurityQuestionCount}}</span>
              security question(s) that will help you access your account if you forget your password.
              Security questions are also used to help protect your account from fraudulent use.
            </span>
          </div>
          <div [formGroup]="securityQuestionForm" novalidate>
            <div class="row form-horizontal padding-left-base" formArrayName="securityQuestion">
              <div class="container-fluid"
                *ngFor="let security of securityQuestionForm['controls'].securityQuestion['controls']; let i=index">
                <div [formGroupName]="i">
                  <div class="form-group">
                    <div>
                      Question {{i+1}}
                      <span class="badge cursor-pointer" style="background-color: white;"
                        *ngIf="this.securityQuesitons.controls[i].value.warning">
                        <i class="material-icons" style="color:red; font-size: 22px; margin-top: -1px;"
                          title="This question is selected. Choose another question."> error</i>
                      </span>
                    </div>
                    <div>
                      <able-dropdown [currentDropValue]="dropdownCurrentQuestion"
                        [dropdownList]="this.securityQuestionList" [fullWidthButton]="true"
                        (OnChange)="onSelectSecurityQuestion($event, i)">
                      </able-dropdown>
                    </div>
                  </div>

                  <div>
                    <div class="form-group label-floating is-empty">
                      <label class="control-label">Answer {{i+1}}</label>
                      <input class="form-control" type="text" formControlName="answer">

                      <div *ngIf="this.identityTypeResponse">
                        <span class="text-danger" style="font-size: smaller"
                          *ngIf="security.controls['answer'].hasError('minlength')">
                          The answer must be at least {{this.identityTypeResponse.minSecurityQuestionAnswerLengths}}
                          characters long.
                        </span>
                      </div>

                      <span class="text-danger" style="font-size: smaller"
                        *ngIf="security.controls['answer'].hasError('pattern')">
                        Only alphanumeric characters allowed.
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="footer text-center">
            <button class="btn btn-primary btn-block" [disabled]="!isSaveEnabled()" (click)="submitQuestions()">Submit
              questions</button>
          </div>
          <div *ngIf="!this.resetPasswordAfterExpire" class="footer text-center">
            <button class="btn btn-primary btn-block" (click)="enterContextualisation()">Skip</button>
          </div>

          <div *ngIf="this.resetPasswordAfterExpire" class="footer text-center">
            <button class="btn btn-primary btn-block" (click)="skipSecurityQuestionsAfterResetPassword()">Skip</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
